<template>
	<div class="invoices">
		<div class="jumbotron">
			<div class="container">
				<h1 class="display-3">Fakture</h1>
				<p>Pregled i kreiranje faktura.</p>
				<p class="lead">
					<button type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#invoice-modal">Kreiraj fakturu</button>
				</p>
			</div>
		</div>

		<div class="container">
			<table class="table table-responsive">
				<thead class="thead-dark">
					<tr>
						<th>#</th>
						<th>Klijent</th>
						<th>Tip</th>
						<th>Datum izdavanja</th>
						<th>Ukupno</th>
						<th>Uplate</th>
						<th class="shrink-column"></th>
					</tr>
				</thead>
				<tbody v-for="year in years">
					<tr class="table-secondary text-center">
						<th scope="row" colspan="7"><h3>{{year}}</h3></th>
					</tr>
					<tr v-for="invoice in groupedInvoices[year]">
						<th scope="row">{{invoice.number}}</th>
						<td>{{invoice.client.name}}</td>
						<td>{{(invoice.type === 'invoice') ? 'Račun' : ((invoice.type === 'proinvoice') ? 'Predračun' : '?')}}</td>
						<td>{{invoice.issueDate | date}}</td>
						<td>{{invoice.total | money}}</td>
						<td>
							<template v-if="!invoice.referenceInvoice">
								<p class="mb-1" v-if="!isInvoicePaid(invoice)"><span class="badge" v-bind:class="[ isDeadlinePassed(invoice.paymentDeadline.toDate()) ? 'badge-danger' : 'badge-light' ]">Rok: {{invoice.paymentDeadline.toDate() | fromNow}}</span></p>
								<table class="table table-sm small" style="width: auto; margin-bottom: 0;">
									<tbody>
										<tr v-for="(payment, index) in invoice.payments">
											<td>{{payment.date | date}}</td>
											<td class="text-right">{{payment.amount | money}}</td>
											<td class="shrink-column">
												<button type="button" class="btn btn-light btn-xs" @click="removePayment(invoice.id, index)"><i class="material-icons">close</i></button>
											</td>
										</tr>
									</tbody>
								</table>
								<button type="button" class="btn btn-light btn-sm" data-toggle="modal" data-target="#payment-modal" @click="showAddPayment(invoice.id)" v-if="!isInvoicePaid(invoice)">Dodaj uplatu</button>
								<button type="button" class="btn btn-light btn-sm" data-toggle="modal" data-target="#pro2invoice-modal" @click="showConvertProToInvoice(invoice.id)" v-if="invoice.type === 'proinvoice'"><i class="material-icons md-18">assignment</i> Napravi račun</button>
							</template>
						</td>
						<td class="shrink-column">
							<router-link :to="{ path: '/invoices/' + invoice.id }" exact class="btn btn-light btn-sm"><i class="material-icons md-18">open_in_new</i></router-link>
							<button type="button" class="btn btn-light btn-sm" @click="removeInvoice(invoice.id)"><i class="material-icons md-18">delete</i></button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div id="payment-modal" class="modal fade" tabindex="-1" role="dialog" ref="paymentModal">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Nova uplata</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form>
							<div class="form-group">
								<label>Datum</label>
								<flat-pickr v-model="currentPayment.date" class="form-control form-control-sm"></flat-pickr>
							</div>
							<div class="form-group">
								<label>Iznos</label>
								<input type="number" step="0.01" class="form-control form-control-sm" v-model="currentPayment.amount">
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Odustani</button>
						<button type="button" class="btn btn-primary" @click="savePayment">Sačuvaj</button>
					</div>
				</div>
			</div>
		</div>

		<div id="pro2invoice-modal" class="modal fade" tabindex="-1" role="dialog" ref="pro2InvoiceModal">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Faktura {{nextInvoiceNumber}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form>
							<div class="form-group">
								<label>Datum izdavanja</label>
								<flat-pickr v-model="currentInvoice.issueDate" class="form-control form-control-sm"></flat-pickr>
							</div>
							<div class="form-group">
								<label>Datum prometa</label>
								<flat-pickr v-model="currentInvoice.deliveryDate" class="form-control form-control-sm"></flat-pickr>
							</div>
							<div class="form-group">
								<label>Rok za plaćanje</label>
								<div class="input-group">
									<input type="number" min="1" v-model="currentInvoice.paymentDeadline" class="form-control">
									<div class="input-group-append">
										<div class="input-group-text">dana</div>
									</div>
								</div>
							</div>
							<div class="form-group">
								<label>Napomena</label>
								<textarea class="form-control" rows="2" v-model="currentInvoice.note"></textarea>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Odustani</button>
						<button type="button" class="btn btn-primary" @click="convertProToInvoice">Napravi račun</button>
					</div>
				</div>
			</div>
		</div>

		<div id="invoice-modal" class="modal fade" tabindex="-1" role="dialog" ref="invoiceModal">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Faktura {{nextInvoiceNumber}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form>
							<div class="form-check form-check-inline">
								<input class="form-check-input" type="radio" name="type" value="invoice" v-model="currentInvoice.type">
								<label class="form-check-label">Račun</label>
							</div>
							<div class="form-check form-check-inline">
								<input class="form-check-input" type="radio" name="type" value="proinvoice" v-model="currentInvoice.type">
								<label class="form-check-label">Predračun</label>
							</div>
							<div class="form-row">
								<div class="form-group col-md-6">
									<label>Klijent</label>
									<select class="form-control" v-model="currentInvoice.client">
										<option v-for="client in clientState.clients" v-bind:value="client">{{client.name}}</option>
									</select>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>Datum izdavanja</label>
									<flat-pickr v-model="currentInvoice.issueDate" class="form-control"></flat-pickr>
								</div>
								<div class="form-group col-md-4">
									<label>Mesto izdavanja</label>
									<input type="text" v-model="currentInvoice.issuePlace" class="form-control">
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-4" v-show="currentInvoice.type === 'invoice'">
									<label>Datum prometa</label>
									<flat-pickr v-model="currentInvoice.deliveryDate" class="form-control"></flat-pickr>
								</div>
								<div class="form-group col-md-4">
									<label>Rok za plaćanje</label>
									<div class="input-group">
										<input type="number" min="1" v-model="currentInvoice.paymentDeadline" class="form-control">
										<div class="input-group-append">
											<div class="input-group-text">dana</div>
										</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-8">
									<label>Napomena</label>
									<textarea class="form-control" rows="2" v-model="currentInvoice.note"></textarea>
								</div>
							</div>
						</form>

						<table class="table table-hover table-responsive table-sm mt-4">
							<thead class="thead-default">
								<tr>
									<th>#</th>
									<th>Naziv usluge</th>
									<th>Količina</th>
									<th>Cena</th>
									<th>Ukupno</th>
									<th class="shrink-column"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in currentInvoice.items">
									<th scope="row">{{index + 1}}</th>
									<td class="w-50"><input type="text" class="form-control form-control-sm form-control-plaintext" v-model="item.name"></td>
									<td><input type="number" min="1" step="1" class="form-control form-control-sm form-control-plaintext" v-model="item.quantity"></td>
									<td><input type="number" step="0.01" class="form-control form-control-sm form-control-plaintext" v-model="item.price"></td>
									<td>{{(item.quantity * item.price) | money}}</td>
									<td class="shrink-column">
										<button type="button" class="btn btn-light btn-sm" @click="removeInvoiceItem(index)"><i class="material-icons md-18">delete</i></button>
									</td>
								</tr>
							</tbody>
						</table>

						<button type="button" class="btn btn-dark btn-sm" @click="addInvoiceItem"><i class="material-icons md-18">add</i> Dodaj stavku</button>

						<h3 class="text-right mt-4"><small class="text-muted">Ukupno</small> {{currentInvoiceTotal | money}}</h3>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Odustani</button>
						<button type="button" class="btn btn-primary" @click="saveInvoice">Sačuvaj</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { invoiceStore } from '../stores/invoices';
import { clientStore } from '../stores/clients';
import moment from 'moment';
import _ from 'lodash';

export default {
	name: 'invoices',

	data() {
		return {
			invoiceState: invoiceStore.state,
			clientState: clientStore.state,
			currentInvoice: invoiceStore.createEmpty(),
			currentPayment: {}
		};
	},

	computed: {
		currentInvoiceTotal() {
			if (this.currentInvoice.items.length === 0)
				return 0.0;

			return this.currentInvoice.items.reduce((accumulator, currentValue) => currentValue.quantity * currentValue.price + accumulator, 0.0);
		},

		nextInvoiceNumber() {
			return (this.invoiceState.invoices.length + 1);
		},

		groupedInvoices() {
			return _.groupBy(this.invoiceState.invoices, invoice => {
				return moment(invoice.issueDate.toDate()).year();
			});
		},

		years() {
			return Object.keys(this.groupedInvoices).sort().reverse();
		}
	},

	mounted() {
		window.jQuery(this.$refs.invoiceModal).on('hidden.bs.modal', (e) => {
			this.currentInvoice = invoiceStore.createEmpty();
		});

		window.jQuery(this.$refs.paymentModal).on('hidden.bs.modal', (e) => {
			this.currentPayment = {};
		});

		window.jQuery(this.$refs.pro2InvoiceModal).on('hidden.bs.modal', (e) => {
			this.currentInvoice = invoiceStore.createEmpty();
		});
	},

	methods: {
		saveInvoice() {
			let invoice = {
				number: this.nextInvoiceNumber,
				type: this.currentInvoice.type,
				client: this.currentInvoice.client,
				issueDate: moment(this.currentInvoice.issueDate).toDate(),
				issuePlace: this.currentInvoice.issuePlace,
				deliveryDate: (this.currentInvoice.type === 'invoice') ? moment(this.currentInvoice.deliveryDate).toDate() : null,
				paymentDeadline: moment(this.currentInvoice.issueDate).add(this.currentInvoice.paymentDeadline, 'days').toDate(),
				note: this.currentInvoice.note,
				items: this.currentInvoice.items.map((item) => {
					return {
						name: item.name,
						quantity: parseInt(item.quantity, 10),
						price: parseFloat(item.price),
						total: parseFloat(item.quantity * item.price)
					};
				}),
				total: parseFloat(this.currentInvoiceTotal)
			};

			invoiceStore.save(invoice)
				.then((docRef) => {
					this.$toasted.success('Faktura sačuvana.', {
						icon: 'done'
					});

					window.jQuery(this.$refs.invoiceModal).modal('hide');
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo čuvanje fakture. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		},

		removeInvoice(id) {
			invoiceStore.delete(id)
				.then(() => {
					this.$toasted.success('Faktura obrisana.', {
						icon: 'done'
					});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo brisanje fakture. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		},

		showAddPayment(invoiceId) {
			let invoice = invoiceStore.get(invoiceId);

			let paid = (invoice.payments || []).reduce((accumulator, currentValue) => currentValue.amount + accumulator, 0.0);

			this.currentPayment = {
				date: moment().format('YYYY-MM-DD'),
				amount: invoice.total - paid,
				invoiceId: invoiceId
			};
		},

		savePayment() {
			let invoice = invoiceStore.get(this.currentPayment.invoiceId);

			let payments = invoice.payments || [];

			payments.push({
				date: this.currentPayment.date,
				amount: parseFloat(this.currentPayment.amount)
			});

			invoiceStore.update(this.currentPayment.invoiceId, { payments: payments })
				.then(() => {
					this.$toasted.success('Uplata sačuvana.', {
						icon: 'done'
					});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo čuvanje uplate. ' + error.toString(), {
						icon: 'error_outline'
					});
				})
				.then(() => {
					window.jQuery(this.$refs.paymentModal).modal('hide');
				});
		},

		removePayment(invoiceId, index) {
			let invoice = invoiceStore.get(invoiceId);

			invoiceStore.update(invoiceId, { payments: invoice.payments.splice(index, 1) })
				.then(() => {
					this.$toasted.success('Uplata obrisana.', {
						icon: 'done'
					});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo brisanje uplate. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		},

		addInvoiceItem() {
			this.currentInvoice.items.push({
				name: '',
				quantity: 1,
				price: 0.00
			});
		},

		removeInvoiceItem(index) {
			this.currentInvoice.items.splice(index, 1);
		},

		showConvertProToInvoice(invoiceId) {
			let invoice = invoiceStore.get(invoiceId);

			this.currentInvoice.referenceProinvoice = invoice.id;
			this.currentInvoice.issueDate = moment().format('YYYY-MM-DD');
			this.currentInvoice.deliveryDate = moment().format('YYYY-MM-DD');
		},

		convertProToInvoice() {
			let proinvoice = invoiceStore.get(this.currentInvoice.referenceProinvoice);

			let invoice = {
				number: this.nextInvoiceNumber,
				type: 'invoice',
				client: proinvoice.client,
				issueDate: moment(this.currentInvoice.issueDate).toDate(),
				issuePlace: proinvoice.issuePlace,
				deliveryDate: moment(this.currentInvoice.deliveryDate).toDate(),
				paymentDeadline: moment(this.currentInvoice.issueDate).add(this.currentInvoice.paymentDeadline, 'days').toDate(),
				note: this.currentInvoice.note,
				items: proinvoice.items,
				total: proinvoice.total,
				referenceProinvoice: this.currentInvoice.referenceProinvoice,
				payments: proinvoice.payments || null
			};

			invoiceStore.save(invoice)
				.then((docRef) => {
					this.$toasted.success('Faktura sačuvana.', {
						icon: 'done'
					});

					invoiceStore.update(this.currentInvoice.referenceProinvoice, { referenceInvoice: docRef.id })
						.catch((error) => {
							this.$toasted.error('Nije uspelo označavanje referentne profakture. ' + error.toString(), {
								icon: 'error_outline'
							});
						})
						.then(() => {
							window.jQuery(this.$refs.pro2InvoiceModal).modal('hide');
						});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo čuvanje fakture. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		},

		isDeadlinePassed(deadline) {
			return moment(deadline).isSameOrBefore();
		},

		isInvoicePaid(invoice) {
			return (invoice.payments || []).reduce((accumulator, currentValue) => currentValue.amount + accumulator, 0.0) >= invoice.total;
		}
	}
};
</script>

<style lang="scss" scoped>
.table .shrink-column {
	white-space: nowrap;
	width: 0.1%;
}

.table td, .table th {
	vertical-align: middle;
}

.table td .form-check {
	margin-bottom: 0;
}

.table .btn-xs {
	padding: 0;
	line-height: 1;

	> .material-icons {
		font-size: inherit;
	}
}
</style>



// WEBPACK FOOTER //
// Invoices.vue?5228e7c7